import { useInfiniteQuery } from '@tanstack/react-query';

import { contractsInfiniteQueryOptions } from '../data-provider/search-contracts';
import type { ContractsSearchParams } from '../models';

export const useContracts = (filters: ContractsSearchParams, enabled = true) => {
  return useInfiniteQuery(contractsInfiniteQueryOptions(filters, enabled));
};
